import script from "./product-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./product-detail.vue?vue&type=script&setup=true&lang=js"

import "./product-detail.vue?vue&type=style&index=0&id=92a70270&lang=less&scoped=true"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92a70270"]])

export default __exports__